<template>
  <section class="content">
    <template v-for="alert in alerts">
      <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
        <h4>
          <i v-if="alert.type == 'success' || alert.type == 'warning' "class="icon fa fa-check"></i>
          <i class="icon fa fa-ban" v-else></i>
          {{'alert_'+alert.type | translate}}!</h4>
        {{alert.message}}
      </b-alert>
    </template>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{'fibu' | translate}}</h3>
        <div class="box-tools pull-right">
          <button type="button" class="btn btn-box-tool" data-widget="collapse">
            <i class="fa fa-minus"></i>
          </button>
        </div>
      </div>
      <div class="box-controls">
        <div class="row">
          <div class="col-md-2 col-sm-6">
            <div class="input-group">
              <div class="input-group-addon">{{'show' | translate | capitalize}}:</div>
              <select id="count-select" class="form-control" v-model="count" @change.prevent="paginate('count','')">
                <option class="normal" value="10">10</option>
                <option class="normal" value="25">25</option>
                <option class="normal" value="50">50</option>
                <option class="normal" value="100">100</option>
              </select>
            </div>
          </div>
          <div class="col-md-10 col-sm-6">
            <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="collapse in" id="coll1">
              <div class="pt-10 row">
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <input type="text" name="search" v-model="filters.orderId" class="form-control" :placeholder="'order_id' | translate" @keyup.13.prevent="paginate('','')" @blur="paginate('','')">
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn"><i class="fa fa-search"></i></button>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <input type="text" name="search" v-model="filters.extOrderId" class="form-control" :placeholder="'order_id_ext' | translate" @keyup.13.prevent="paginate('','')" @blur="paginate('','')">
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn"><i class="fa fa-search"></i></button>
                    </div>
                  </div>
                </div>
                <div class="col-md-2 col-sm-6">
                  <div class="input-group">
                    <div class="input-group-addon">{{'booked' | translate}}</div>
                    <select v-model="filters.booked" class="form-control" @change.prevent="paginate('booked')">
                      <option class="normal" value="all">{{'all' | translate}}</option>
                      <option class="normal" value="true">{{'yes' | translate}}</option>
                      <option class="normal" value="false">{{'no' | translate}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2 col-sm-6">
                  <div class="input-group">
                    <div class="input-group-addon">{{'ideal_booked' | translate}}</div>
                    <select v-model="filters.idealBooked" class="form-control" @change.prevent="paginate('idealBooked')">
                      <option class="normal" value="all">{{'all' | translate}}</option>
                      <option class="normal" value="true">{{'yes' | translate}}</option>
                      <option class="normal" value="false">{{'no' | translate}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2 col-sm-6">
                  <div class="input-group">
                    <div class="input-group-addon">{{'type' | translate}}</div>
                    <select v-model="filters.type" class="form-control" @change.prevent="paginate('idealBooked')">
                      <option class="normal" value="all">{{'all' | translate}}</option>
                      <option class="normal" value="return">{{'return_correction' | translate}}</option>
                      <option class="normal" value="payment">{{'invoice' | translate}}</option>
                      <option class="normal" value="reduction">{{'price_reduction' | translate}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-right">
          </div>
        </div>
      </div>
      <div class="box-body">
        <div class="overlay" v-if="loading">
          <img class="loading-gif" src="/static/img/blabla.svg"/>
        </div>
        <div v-else class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>{{'order' | translate}} ID</th>
                <th>{{'marketplace' | translate}}</th>
                <th>{{'booking_type' | translate}}</th>
                <th>QB-{{'booking' | translate}}</th>
                <th>Ideal {{'booking' | translate}}</th>
                <th>QB-{{'booking_file' | translate}}</th>
                <th>QB-{{'invoice' | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item, index in pagination.data">
                <td>
                  {{'order_date' | translate}}: {{item.order_date | orderDateApi}}<br/>
                  {{'order_id' | translate}}: {{item.order_id}}<br/>
                  {{'marketplace' | translate}} Nr: {{item.ext_order_id}}
                </td>
                <td><img class="img-responsive img-channel" :src="`/static/img/${item.marketplace}.svg`"></td>
                <td>{{ item.type}}</td>
                <td>
                  {{'amount' | translate}}: {{item.booking_total}}<br/>
                  {{'date' | translate}}: {{item.record_date | orderDateApi}}<br/>
                </td>
                <td>
                  {{'amount' | translate}}: {{item.ideal_booking_total !== '' ? item.ideal_booking_total : 'Ø'}}<br/>
                  <template v-if="item.ideal_booking_date !== null ">
                    {{'date' | translate}}: {{item.ideal_booking_date | orderDateApi}}
                  </template>
                  <br/>
                </td>
                <td>
                  <a class="btn btn-success" target="_blank" :href="item.ideal_booking_path"><i class="fa fa-cloud-download mr-5"></i>{{'download' | translate}}!</a>
                </td>
                <td>
                  <a class="btn btn-success" target="_blank" :href="item.invoice_path"><i class="fa fa-cloud-download mr-5"></i>{{'download' | translate}}!</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
	import VueMonthlyPicker from 'vue-monthly-picker'
	export default {
		data () {
			return {
			  loading: true,
				alerts: [],
				ready: [],
				count: 25,
        filters: {
          orderId: '',
          extOrderId: '',
          type: 'all',
          booked: 'all',
          idealBooked: 'all'
        },
				page: 0,
				sortKey: '',
				pagination: {
					total: 0,
					per_page: 25,
					current_page: 1,
					total_pages: 0
				},
				filePath: []
			}
		},
		components: {
			VueMonthlyPicker: VueMonthlyPicker
		},
		methods: {
			download (id, index) {
				API.get(`download/invoices/${this.$route.params('type')}/${id}`, {})
					.then(response => {
						this.filePath[index] = response.data.invoice_path
            this.filePath = [...this.filePath]
            this.ready[index] = 'download'
            this.ready = [...this.ready]
					}).catch(error => {
					if (this.checkError(error)) {
						let alert = {type: 'danger', dismiss: 4, message: this.translate(error.body.error_code) || error.body.error_message}
						this.alerts.push(alert)
					}
				})
			},
			formatForSending (date) {
				let d = date.split('/')
				let aux = d[1]
				d[1] = d[0]
				d[0] = d[2]
				d[2] = aux
				return date === '' ? '' : d.join('-')
			},
			updateValue (event, type) {
				type === 'start' ? this.date.startDate = event.target.value : this.date.endDate = event.target.value
				this.paginate('date', '', event)
			},
			paginate (type, value) {
			  this.loading = true
			  let ftype, ideal, booked
        ftype = this.filters.type === 'all' ? '' : this.filters.type
        ideal = this.filters.idealBooked === 'all' ? '' : this.filters.idealBooked
        booked = this.filters.booked === 'all' ? '' : this.filters.booked
        let url =  'controlling/orderEvaluation?order_id=' + this.filters.orderId +
                   '&ext_order_id=' + this.filters.extOrderId +
                   '&type=' + ftype +
                   '&is_booked=' + booked +
                   '&is_ideal_booked=' + ideal +
                   '&count=' + this.count +
                   '&page=' + this.pagination.current_page
				if (type === 'page') {
					url += '&page='
					if (value === 'previous') {
						url += (this.pagination.current_page - 1)
					}
					if (value === 'next') {
						url += this.pagination.current_page >= this.pagination.last_page ? this.pagination.last_page : (this.pagination.current_page + 1)
					} else if (value !== 'next' && value !== 'previous') {
						url += value
					}
				}
				API.get(url, {})
					.then(response => {
						this.pagination = response.data
            this.loading = false
					})
          .catch(error => {
            this.loading = false
					  this.checkError(error)
				  })
			},
			getFIBU () {
        this.invoiceNumber = ''
        this.selectedOrder = ''
        this.selectedChannel = 0
        this.selectedCompany = ''
        this.selectedMonth = moment().subtract(1, 'month')
				API.get('controlling/orderEvaluation', {})
					.then(response => {
            this.pagination = response.data
            this.loading = false
					})
          .catch(error => {
            this.loading = false
            this.checkError(error)
          })
			}
		},
		mounted () {
			this.$nextTick(function () {
				this.getFIBU()
			})
		},
		watch: {
			'$route.params' () {
				this.getInvoices()
			}
		}
	}
</script>
<style>
  .date-popover {
    overflow-x: hidden;
    overflow-y: hidden;
    outline: none;
    max-width: 350px;
    width: 100%;
    border-radius: 0 0 .28571429rem .28571429rem;
    box-shadow: 0 2px 3px 0 rgba(34,36,38,.15);
    background: #212228 !important;
    transition: opacity .1s ease;
    position: relative;
    margin: auto;
    z-index: 10;
    border: 1px solid;
    font-size: 1rem;
    font-weight: 200;
  }
  .picker .monthItem .item.active:hover{
    border-top: 1px solid;
    cursor: pointer;
    background-color: rgba(0,195,150,.4) !important;
    border-color: rgba(0,195,150,1) !important;

  }
</style>
<style scoped>
  .loading-gif {
    top: 43%;
    left: 39%;
    width: 23%;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Fibu.vue